import { createApp } from 'vue'
import store from './store/index'
import router from './routes/index.js'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import './assets/styles/index.css'

const app = createApp(App)
for (const [ key, component ] of Object.entries(ElementPlusIconsVue))
{
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus)

app.mount('#app')